import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from "../../Assets/Images/Logo.png";
import { BsChat, BsPerson } from 'react-icons/bs';
import { MdEmail, MdPhone } from 'react-icons/md';
import { Link } from 'react-router-dom';
import './Style.css'
function MainNavbar() {
  return (
    <Navbar expand="lg" sticky="top" className="glass-navbar">
      <Container>

        {/* Logo / Brand */}
        <Navbar.Brand as={Link} to="/">
          <img width="50px" src={Logo} alt="ibinsina logo" />
        </Navbar.Brand>

        {/* Hamburger button */}
        <Navbar.Toggle aria-controls="main-navbar" />

        <Navbar.Collapse id="main-navbar">
          <Nav className="w-100 d-flex flex-column flex-lg-row justify-content-lg-around align-items-center">

            <Nav.Link href="/#agent-pricing">عامل های هوشمند</Nav.Link>
            <Nav.Link href="/#plan-pricing">هوشمندسازی سازمانی</Nav.Link>
            <Nav.Link as={Link} to="/solutions">سایر راهکارها</Nav.Link>
            <Nav.Link href="/#faq">سوالات متداول</Nav.Link>
            <Nav.Link href="/#about-us">درباره ما</Nav.Link>
            <Nav.Link href="tel:+989127792668">
              <MdPhone className='text-primary' size="25px"/>
            </Nav.Link>

            <Nav.Link href='https://ble.ir/ibinsina_support'>
              <BsChat className='text-primary' size="25px"/>
            </Nav.Link>

            <Nav.Link href='https://panel.ibinsina.com'>
              <BsPerson className='text-primary' size="25px"/>
            </Nav.Link>

          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
}

export default MainNavbar;
